import type { Connector, UseAccountReturnType } from "wagmi"
import type { Address } from "../../types"

type PopulatedWagmiAccountReturn = UseAccountReturnType & {
  address: Address
  chainId: number
  connector: Connector
}

/**
 * Returns boolean indicating whether the given account is a wagmi account.
 * Used with return value of `wagmi` `useAccount` hook since the return value
 * can be unpopulated when no account is connected.
 */
export function isWagmiAccount(
  account: UseAccountReturnType,
): account is PopulatedWagmiAccountReturn {
  return (
    account.address !== undefined &&
    account.chainId !== undefined &&
    account.connector !== undefined
  )
}

export function isAbstractWalletAccount(connectorId: string) {
  return connectorId === "xyz.abs.privy"
}

export function isGlyphWalletAccount(connectorId: string) {
  return connectorId === "io.useglyph.privy"
}
